import { TooltipButton } from '../../../../inputs';
import React, { Component } from 'react';

export default class ActionBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }

    btnClickedHandler() {
        this.props.clicked(this.props.value);
    }

    render() {
        var { props } = this;
        var { colDef, data } = props;
        var { additionalParams } = colDef;

        const {
            getLRFRelatedData,
            history,
            voidAuthorized,
            isReadonly,
            canViewJobOrders,
        } = this.props;

        return (
            <div key={`action_container_${data.recruitmentRequestId}`} className="text-center">
            {
                isReadonly ?
                null
                :
                <TooltipButton
                    id={`edit_${data.recruitmentRequestId}`}
                    title="Edit"
                    className="btn-icon"
                    color="default"
                    size="xss"
                    type="button"
                    onClick={(event) => { history.push(`/lrf/${data.recruitmentRequestId}`) }}
                >
                    <i className="fa fa-xs fa-pencil-alt pt-1"></i>
                </TooltipButton>
            }
            {
                canViewJobOrders ?
                <TooltipButton
                    id={`joborders_${data.recruitmentRequestId}`}
                    title="View Job Orders"
                    className="btn-icon"
                    color="default"
                    size="xss"
                    type="button"
                    onClick={(event) => { history.push(`/joborder/${data.recruitmentRequestId}/request`) }}
                >
                    <i className="fa fa-xs fa-link pt-1"></i>
                </TooltipButton>
                :
                null
            }
            {
                voidAuthorized && data.status?.lookupValue === "Approved" && !isReadonly &&
                <TooltipButton
                    id={`void_${data.recruitmentRequestId}`}
                    title="Void"
                    className="btn-icon"
                    color="default"
                    size="xss"
                    type="button"
                    onClick={() => this.props.getLRFRelatedData(data)}
                >
                    <i className="fa fa-xs fa-trash-alt pt-1"></i>
                </TooltipButton>
            }
            </div>
        );


    }
}
